import { gql } from '@apollo/client';

const OrganizationDetailsFragment = gql`
  fragment OrganizationDetails on OrganizationDetails {
	  active
	  companyId
	  colorTheme: defaultTheme
	  name
	  organizationNumber: orgNo
	  publicCompanyId
	  vatNumber: vatNo
	  visibility
	  website
    #contactPerson
    #email
    #telephone
    #reference
  }
`;

export default OrganizationDetailsFragment;
